import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Footer.module.css";
import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { CMSContext } from "../Context/CmsContext";
import DICGC from "../../assets/smart/DIGCLogo_HighRes.jpg";
import qrCode from "../../assets/smart/qrCode.jpg";
import config from "../../Config/Config";

const Footer = () => {
  const { cmsData } = useContext(CMSContext);
  const navigate = useNavigate();

  if (!Array.isArray(cmsData)) {
    return null; // Or a loading spinner
  }

  const handleHomeNavigation = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  const handleNavigation = (service, title, id) => {
    if (service && title && id) {
      // Dynamically construct the path
      navigate(
        `/${service.toLowerCase()}/${title
          .toLowerCase()
          .replace(/\s+/g, "-")}/${id}`,
      );
    } else if (service && !title && !id) {
      // For services that don't require title or id (like "Home")
      navigate(`/${service.toLowerCase()}`);
    } else {
      console.error("Missing navigation parameters:", { service, title, id });
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0); // Scroll to the top
  };

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerFirst}>
        <h2>Quick Links</h2>
        <Link to="/" onClick={scrollToTop}>
          Home
        </Link>
        <Link to="/GetInTouch" onClick={scrollToTop}>
          Contact Us
        </Link>
        {cmsData
          .filter((item) => item.status === 1 && item.service === "AboutUS")
          .map((item) => (
            <a
              key={item.id}
              onClick={() => handleNavigation("service", item.title, item.id)}
              href="#"
            >
              {item.title}
            </a>
          ))}
        {/* {cmsData
          .filter(
            (item) => item.title === "Notices Document" && item.status === 1
          )
          .map((item) => (
            <Link
              key={item.id}
              to={`/${item.service}/${item.title.replace(/\s+/g, "-")}/${
                item.id
              }`}
              onClick={scrollToTop}
            >
              Notices / Documents
            </Link>
          ))} */}
        {/* <Link
          to={`${config.FILE_BASE_URL}/document/1749429696038-SMS-INTERNET.pdf`}
          onClick={scrollToTop}
        >
          SMS / Internet Banking
        </Link> */}
        {/* <Link
          to={`${config.FILE_BASE_URL}/document/1749426666514-Death%20Claim%20Form.pdf`}
          onClick={scrollToTop}
        >
          CLAIM FORM - Death Claim Form
        </Link>
        <Link
          to={`${config.FILE_BASE_URL}/document/1749429607875-RTGSFORM.pdf`}
          onClick={scrollToTop}
        >
          RTGS / NEFT - Request Form
        </Link> */}
        {/* <a
          href="https://www.khattribank.com/upload/document/1749430900965-Privacy%20Policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a> */}
        <Link to="/privacy-policy" onClick={scrollToTop}>
          Privacy Policy
        </Link>
      </div>
      <div className={styles.footerFirst}>
        <h2>Customer Awareness Links / Complaints</h2>
        <a
          href="https://khattri.bank.in/upload/document/1776704727803-FLOW%20CHART%20CUSTOMER%20COMPLAINTS%20(1).pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Flow Chart- Customer Complaints
        </a>
        <a
          href="https://www.upichalega.com/safety-season1"
          target="_blank"
          rel="noopener noreferrer"
        >
          UPI – Safety – tips
        </a>
        <a
          href="https://rbikehtahai.rbi.org.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          RBI – Kehta Hai – A Public Awareness
        </a>
        <a
          href="https://cms.rbi.org.in/cms/indexpage.html#eng"
          target="_blank"
          rel="noopener noreferrer"
        >
          RBI – Integrated Ombudsman 2021
        </a>
        <a
          href="https://www.npci.org.in/what-we-do/upi/dispute-redressal-mechanism"
          target="_blank"
          rel="noopener noreferrer"
        >
          Lodge UPI Complaints directly through NPCI Portal
        </a>
      </div>
      <div className={styles.footerSecond}>
        <div className={styles.images}>
          <img src={DICGC} alt="DICGC" className={styles.logoImage} />
          <img src={qrCode} alt="qrCode" className={styles.logoImage} />
        </div>
      </div>
      <div className={styles.footerThird}>
        <div className={styles.logoBox}>
          <img
            src={logo}
            alt="logo"
            className={styles.logoImage}
            onClick={handleHomeNavigation}
          />
          <p>Copyright© 2025</p>
          <p onClick={handleHomeNavigation}>
            The Khattri Co-operative Urban (U) <br /> Bank LTD.
          </p>
        </div>
      </div>
      <div className={styles.footerFourth}>
        <p>Customer Care</p>
        <a href="tel:+923278102" style={{ color: "white" }}>
          <h3>+91-011-41251490</h3>
        </a>
        <a href="tel:+923278103" style={{ color: "white" }}>
          <h3>+91-011-23278103</h3>
        </a>
        <p>Banking Hours</p>
        <h3>Mon to Fri</h3>
        <h3>10:00am to 5:00pm</h3>

        <h3>
          Regd. Office -24, Darya Ganj <br />
          New Delhi -110002.
        </h3>
        <a href="mailto:information@khattribank.com">
          <FontAwesomeIcon
            icon={faEnvelope}
            size="20px"
            color="white"
            style={{ marginRight: "8px" }}
          />
          information@khattribank.com
        </a>
        <h3>ATM & UPI Customer Care - 1800220199</h3>
      </div>
    </div>
  );
};

export default Footer;
